<template>
  <div class="form-item">
    <div v-if="label || $slots.label" class="label" :style="labelWrapStyle">
      <span v-if="showAsterisk" class="asterisk">*</span>
      <span v-if="label">{{ label }}</span>
      <slot v-else name="label"></slot>
    </div>
    <div
      :class="['form-content', isError && isShowErrorBackgroud ? 'error-content' : '']"
      :style="contentWrapStyle"
    >
      <slot name="default"></slot>
      <div class="form-message">
        <div ref="errorRef" v-show="isError" :class="[isError ? 'error-message' : '']">
          <slot name="error" :error="errMessage"></slot>
          {{ errMessage }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, withDefaults, inject, watch, nextTick } from "vue";
import { FROM_KEY } from "./cy-form.vue";
import type { FormProvide } from "./cy-form.vue";

type Props = {
  label?: string;
  field: string; // 唯一model key
  rules?: { message: string; validator: (bindValue: any) => boolean }[]; // 验证规则 我会把绑定的值传出去
  labelWrapStyle?: Record<string, any>; // label包裹的样式
  contentWrapStyle?: Record<string, any>; // 内容包裹的样式
  isShowErrorBackgroud?: boolean; // 是否需要显示错误背景色
  showAsterisk?: boolean; // 是否需要显示星星
};

const props = withDefaults(defineProps<Props>(), {
  isShowErrorBackgroud: false,
  asterisk: true,
});
const isError = ref(false);
const errMessage = ref("");
const errorRef = ref<HTMLElement>();

const formInfo = inject<FormProvide | null>(FROM_KEY, null);

const setValidate = async (error: any) => {
  isError.value = true;
  errMessage.value = error;
  await nextTick();
  errorRef.value?.classList?.add("shake");
  setTimeout(() => {
    errorRef.value?.classList?.remove("shake");
  }, 500);
};

const clearValidate = () => {
  isError.value = false;
  errMessage.value = "";
  errorRef.value?.classList?.remove("shake");
};

watch(
  () => props,
  (newValue) => {
    if (newValue) {
      formInfo?.pushValidateList(() => {
        return {
          field: props.field,
          rules: props.rules,
          ifOK: () => clearValidate(),
          ifError: (error: any) => setValidate(error),
        };
      });
      formInfo?.pushClearValidate(clearValidate);
      formInfo?.setValidateFun(() => {
        return {
          field: props.field,
          setFun: setValidate,
        };
      });
    }
  },
  { immediate: true }
);
</script>
<style scoped lang="less">
.form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  min-height: 50px;
  .asterisk {
    color: #ff562e;
  }
  .label {
    // margin-right: 10px;
  }
  .form-content {
    // flex: 1;
    width: 100%;
  }
  .form-content.error-content {
    background-color: rgb(255, 236, 232);
    border: transparent;
  }

  .error-content,
  .error-message {
    transition: all 0.6s;
  }

  .form-message {
    font-size: 12px;
    line-height: 16px;
    height: 16px;
    margin-top: 8px;
    margin-left: 20px;
    font-weight: 400;

    .error-message {
      color: #ff562e;
    }
  }
}
</style>
